import React from "react"
import {Container} from "./component"

export type StandardContainerProps = {
    children: React.ReactNode
    onMouseEnter: () => void
    onMouseLeave: () => void
    elementRef: React.MutableRefObject<HTMLDivElement | null>
    xxlBreakpointEnabled: boolean
}

const StandardContainer = ({
    children,
    onMouseEnter,
    onMouseLeave,
    elementRef,
    xxlBreakpointEnabled,
}: StandardContainerProps) => (
    <Container
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        ref={elementRef}
        data-testid="sec-nav-content"
        id="sec-nav-content"
        xxlBreakpointEnabled={xxlBreakpointEnabled}
    >
        {children}
    </Container>
)

export default StandardContainer
